import { useQuery } from '@tanstack/react-query';

import { listInstructionVersions } from '@/services/external-chat/versions';
import { unwrap } from '@/services/external-chat/detail-error';
import type { PromptVersion } from '@/services/external-chat/types';

export const instructionVersionsQueryKey = (
  orgId?: string,
  collectionId?: string,
) => ['external-chat-instruction-versions', orgId, collectionId];

export const useInstructionVersions = (orgId?: string, collectionId?: string) =>
  useQuery<PromptVersion[], Error>({
    queryKey: instructionVersionsQueryKey(orgId, collectionId),
    queryFn: async () =>
      unwrap(await listInstructionVersions(collectionId!)).versions,
    enabled: !!orgId && !!collectionId,
  });
